exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-container[data-v-08d5df00]{z-index:10;position:absolute;top:0;left:0}.popup-container .popup-text[data-v-08d5df00]{opacity:0.8}.popup-container .popup-text .relative[data-v-08d5df00]{top:-2px}.popup-container .tickets-popup[data-v-08d5df00]{z-index:10;margin:0;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}.popup-container .popup[data-v-08d5df00]{z-index:9;opacity:0.1}\n", ""]);

// exports
